export default __webpack_public_path__ + "static/media/kelp-farm.5372c36f.svg";